export default {
  SET_PARTNER_ORDER_REQUESTS(state, payload) {
    state.partnerOrderRequests = payload.items
    state.partnerOrderRequestsTotal = payload.total
    state.partnerOrderRequestsLimit = payload.limit
    state.partnerOrderRequestsPage = payload.page
  },
  SET_PARTNER_ORDER_REQUEST(state, payload) {
    state.partnerOrderRequest = payload
  },
  SET_PARTNER_ORDER_REQUEST_STATUS_TOTALS(state, payload) {
    state.partnerOrderRequestStatusTotals = {
      ...state.partnerOrderRequestStatusTotals,
      ...payload,
    }
  },
  CLEAR_PARTNER_ORDER_REQUEST(state) {
    state.partnerOrderRequest = { ...state.externalOrderRequestModel }
  },
  SET_ALLOWED_CUSTOMERS(state, customers) {
    state.allowedCustomers = customers
  },
  SET_ALLOWED_ORDER_TYPES(state, orderTypes) {
    state.allowedOrderTypes = orderTypes
  },
  SET_PARTNER_ORDER_REQUEST_INSTRUCTION(state, instruction) {
    state.partnerOrderRequestInstruction = instruction
  },
  SET_DISPATCHER_REVIEW_REQUESTS(state, payload) {
    state.dispatcherReviewRequests = payload.items
    state.dispatcherReviewRequestsTotal = payload.total
    state.dispatcherReviewRequestsLimit = payload.limit
    state.dispatcherReviewRequestsPage = payload.page
  },
  SET_DISPATCHER_REVIEW_REQUEST(state, payload) {
    state.dispatcherReviewRequest = payload
  },
  CLEAR_DISPATCHER_REVIEW_REQUEST(state) {
    state.dispatcherReviewRequest = { ...state.externalOrderRequestModel }
  },
  SET_DISPATCHER_REVIEW_PENDING_TOTAL(state, total) {
    state.dispatcherReviewPendingTotal = total
  },
  SET_DISPATCHER_REVIEW_STATUS_TOTALS(state, payload) {
    state.dispatcherReviewStatusTotals = {
      ...state.dispatcherReviewStatusTotals,
      ...payload,
    }
  },
}
